import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import MembersComponent from 'srcReact/components/common2/MembersComponent'
import LightProfileModal from '../LightProfileModal'
import Spinner from '../Spinner'
import { useSelector } from 'react-redux'

export default function MembersTabContent({
  type,
  members,
  scope,
  pagination,
  lastMemberRef,
  membersLoading,
  searchedMemberError,
  current_workplace,
  getMembers,
  setPagination,
  isOrganizer,
  groupRole,
  handleAddCoorganizer,
  handleRemoveCoorganizer,
  handleRemoveFromGroup,
  userAfterRoleChanged,
  userRemoved,
  loggedInUser,
  participants,
  isMixrOver = false,
  isHybridMixr = false,
  setScope
}) {
  const { t } = useTranslation()
  const [order, setOrder] = useState('name')
  const [selectedAttendingType, setSelectedAttendingType] = useState('both')
  const [searchValue, setSearchValue] = useState('')
  const [isChangeRoleTriggered, setIsChangeRoleTriggered] = useState(false)
  const [isRemoveUserTriggered, setIsRemoveUserTriggered] = useState(false)

  const [modalData, setModalData] = useState({
    isShowUserModal: false,
    selectedUserIndex: -1,
    selectedModalUser: {}
  })

  const {
    common: { isNative, isMobile }
  } = useSelector((state) => state)

  useEffect(() => {
    if (type === 'mixr') {
      getMembers(selectedAttendingType, searchValue, order)
    } else {
      getMembers(searchValue, order)
    }
  }, [scope, order, searchValue, pagination, selectedAttendingType])

  useEffect(() => {
    if (userAfterRoleChanged) {
      const newRole = type == 'mixr' ? userAfterRoleChanged.user_mixr_role : userAfterRoleChanged.user_group_role

      setModalData({
        ...modalData,
        selectedModalUser: {
          ...modalData.selectedModalUser,
          role: newRole
        }
      })
      if (isChangeRoleTriggered) {
        setIsChangeRoleTriggered(false)
        if (scope === 'staff_members' || scope === 'staff') {
          //As soon as co-organizer role is removed on tab "Leadership/Organizers", close the popup
          hideUserModal()
        }
      }
    }
  }, [userAfterRoleChanged])

  useEffect(() => {
    if (userRemoved && isRemoveUserTriggered) {
      setIsRemoveUserTriggered(false)
      hideUserModal()
    }
  }, [userRemoved])

  const handleOrderByChange = (order) => {
    setPagination({ nextOffset: 0, isPagination: false })
    setOrder(order.value)
  }

  const handleSearchMember = (searchValue) => {
    if (searchValue.length !== 1) {
      setPagination({ nextOffset: 0, isPagination: false })
      setSearchValue(searchValue)
    }
  }

  const handleAttendingTypeChange = (type) => {
    setPagination({ nextOffset: 0, isPagination: false })
    setSelectedAttendingType(type)
    if (setScope) {
      setScope('participants')
    }
  }

  const handleMixrScopeChange = (type) => {
    setPagination({ nextOffset: 0, isPagination: false })
    if (setScope) {
      setScope(type)
    }
    setSelectedAttendingType('')
  }

  const hideUserModal = () => {
    setModalData({
      ...modalData,
      isShowUserModal: false
    })
  }

  const showUserModal = (user, index) => {
    setModalData({
      isShowUserModal: true,
      selectedUserIndex: index,
      selectedModalUser: user
    })
  }

  const addCoOrganizer = (userId) => {
    setIsChangeRoleTriggered(true)
    if (handleAddCoorganizer) {
      handleAddCoorganizer(userId)
    }
  }

  const removeCoorganizer = (userId) => {
    setIsChangeRoleTriggered(true)
    if (handleRemoveCoorganizer) {
      handleRemoveCoorganizer(userId)
    }
  }

  const removeFromGroup = (userId) => {
    setIsRemoveUserTriggered(true)
    if (handleRemoveFromGroup) {
      handleRemoveFromGroup(userId)
    }
  }

  const navigate = (direction) => {
    const { selectedUserIndex } = modalData
    const nextUserIndex = direction === 'next' ? selectedUserIndex + 1 : selectedUserIndex - 1
    if (nextUserIndex < members.length && nextUserIndex >= 0) {
      const navigatedUser = members[nextUserIndex]
      setModalData({
        ...modalData,
        selectedUserIndex: nextUserIndex,
        selectedModalUser: navigatedUser
      })
    }
  }

  const getOptionsBasedOnRole = () => {
    let options = []
    if (modalData.selectedUserIndex > -1 && loggedInUser.id !== modalData.selectedModalUser.id && !isMixrOver) {
      if (
        (type === 'mixr' && isOrganizer) ||
        (type === 'group' && (groupRole === 'organizer' || groupRole === 'co-organizer'))
      ) {
        if (isOrganizer || groupRole === 'organizer') {
          if (modalData.selectedModalUser.role === 'co-organizer') {
            options.push({
              text: type === 'mixr' ? t('mixrHome.members.removeRole') : t('groupHome.members.removeRole'),
              onClick: () => removeCoorganizer(modalData.selectedModalUser.id)
            })
          } else if (
            (type === 'mixr' && modalData.selectedModalUser.role === 'participant') ||
            scope === 'active_members'
          ) {
            options.push({
              text: type === 'mixr' ? t('mixrHome.members.addCoOrganizer') : t('groupHome.members.addCoOrganizer'),
              onClick: () => addCoOrganizer(modalData.selectedModalUser.id)
            })
          }
        }
        //co-organizer can remove other  non staff members from group
        if (type === 'group' && modalData.selectedModalUser.role !== 'organizer') {
          options.push({
            text: t('groupHome.members.removeMember'),
            onClick: () => removeFromGroup(modalData.selectedModalUser.id)
          })
        }
      }
    }
    return options
  }

  return (
    <React.Fragment>
      <MembersComponent
        members={members}
        participants={participants}
        membersLoading={membersLoading}
        searchedMemberError={searchedMemberError}
        scope={scope}
        type={type}
        order={order}
        isHybridMixr={isHybridMixr}
        lastMemberRef={lastMemberRef}
        selectedAttendingType={selectedAttendingType}
        handleOrderByChange={handleOrderByChange}
        handleSearchMember={handleSearchMember}
        showUserModal={showUserModal}
        handleAttendingTypeChange={handleAttendingTypeChange}
        handleMixrScopeChange={handleMixrScopeChange}
      />

      {modalData.isShowUserModal && (
        <LightProfileModal
          userIdwithRole={modalData.selectedModalUser.id}
          show={modalData.isShowUserModal}
          userswithRole={members}
          userIndexWithRole={modalData.selectedUserIndex}
          roleManagementOptions={getOptionsBasedOnRole()}
          closeModalWithRole={hideUserModal}
          navigateWithRole={navigate}
        />
      )}
      {membersLoading && <Spinner />}
    </React.Fragment>
  )
}
